import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postArchiveProductURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
  } from "@chakra-ui/react";

function CreateProductArchive({
    isOpen,
    onClose,
    successCallback,
    productData
}) {


    const [ comment, setComment ] = useState('');
    const [ invComment, setInvComment ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postArchive = (e) => {
        e.preventDefault();

        setErrors([]);
        setSubmitting(true);
        // console.log(email, password);
        axios.post( postArchiveProductURL(productData.id), 
        {
            comment,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setComment('');
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (!validator.isEmpty(comment)) {
            setInvComment(comment.length < 1);
        }

    }, [comment]);

    if (!productData) {
        return (<></>);
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Request to Archive</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postArchive}>


                    <FormControl >


                    <Flex w="100%" flexDir="column">

                        <Text 
                            fontSize="16px"
                            color={"black"}
                            textAlign="start"
                        >
                            Name: {productData.name}
                        </Text>

                        <Text 
                            fontSize="16px"
                            color={"black"}
                            textAlign="start"
                        >
                            Description: {productData.description}
                        </Text>



                        <Text 
                            fontSize="16px"
                            color={"black"}
                            textAlign="start"
                        >
                            Total Stock: {productData.totalStocks}
                        </Text>
                        

                        { productData.archiveRequest 
                            ? <Text 
                                marginTop="12px"
                                fontSize="14px"
                                textAlign="start"
                                color="orange"
                            >
                                Archive request is pending for approval
                            </Text>
                            : null
                        }

                        { productData.archiveRequest 
                            ? <Text 
                                fontSize="14px"
                                color={"black"}
                                textAlign="start"
                            >
                                Comment: {productData.archiveRequest.requestedComment}
                            </Text>
                            : null
                        }       


                        { productData.archiveRequest 
                            ? <Text 
                                fontSize="14px"
                                color={"grey"}
                                textAlign="start"
                            >
                                Sent at: {new Date(productData.archiveRequest.requestedAt).toLocaleString()}
                            </Text>
                            : null
                        }

                    </Flex>

                    { productData.archiveRequest 
                        ? null 
                        :  <Box pr="12px" marginTop="12px">
                            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                Comment
                            </FormLabel>
                            <Input
                                borderRadius="15px"
                                mb="12px"
                                fontSize="sm"
                                type="text"
                                placeholder="Comment"
                                size="md" 
                                noOfLines={3}
                                isInvalid={invComment === true}
                                isRequired={true}
                                value={comment} 
                                onChange={e => setComment(e.target.value)}
                            />
                        </Box>
                    }
                   

                
                    <Flex w="100%" flexDir="column" marginBottom="12px">
                        { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                    </Flex>

                    { productData.archiveRequest 
                        ? null 
                        :  <Button
                            fontSize="10px"
                            type="submit"
                            bg="teal.300"
                            w="100%"
                            h="45"
                            mb="20px"
                            color="white"
                            mt="0px"
                            _hover={{
                            bg: "teal.200",
                            }}
                            _active={{
                            bg: "teal.400",
                            }}
                            isDisabled={submitting}
                        >
                            SUBMIT
                        </Button>
                    }

                </FormControl>
            </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default CreateProductArchive;
